/* op-luxury.js — comportamiento de las secciones op-lx-* (Hospitality Guest Experience v3).
   1) Aparición al hacer scroll (.rv, .lx-rule--short, .lx-plate.rvp), respeta prefers-reduced-motion.
   2) Tarjeta de muestra del atelier (escribe un nombre y una mesa en vivo).
   3) Consulta privada: chips, campos condicionales, validación y resumen. El envío es el
      formulario de contacto nativo de Shopify; los chips llenan campos ocultos contact[...]. */
(function () {
  if (window.__opLx) return;
  window.__opLx = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* 1) aparición */
  function initReveal() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) return;
    var sel = '.oplx .rv, .oplx .lx-rule--short, .oplx .lx-plate.rvp';
    var nodes = document.querySelectorAll(sel);
    if (!nodes.length) return;
    document.documentElement.classList.add('lx-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach(function (n) {
      if (n.getBoundingClientRect().top < window.innerHeight) n.classList.add('on');
      else io.observe(n);
    });
    // red de seguridad: nada se queda invisible si el observer falla
    setTimeout(function () {
      document.querySelectorAll(sel).forEach(function (n) { n.classList.add('on'); });
    }, 4000);
  }

  /* 2) tarjeta de muestra */
  function initCards() {
    document.querySelectorAll('[data-lx-card]').forEach(function (root) {
      var nameIn = root.querySelector('[data-lx-in="name"]');
      var mesaIn = root.querySelector('[data-lx-in="mesa"]');
      var nameOut = root.querySelector('[data-lx-out="name"]');
      var mesaOut = root.querySelector('[data-lx-out="mesa"]');
      var fallback = root.getAttribute('data-lx-fallback') || 'Nombre del invitado';
      function sync() {
        nameOut.textContent = nameIn.value.trim() || fallback;
        mesaOut.textContent = mesaIn.value.trim() || '1';
      }
      nameIn.addEventListener('input', sync);
      mesaIn.addEventListener('input', sync);
      var cta = root.querySelector('[data-lx-card-cta]');
      if (cta) cta.addEventListener('click', function () {
        var form = document.querySelector('[data-lx-form]');
        if (!form) return;
        form.__lxAddServicio && form.__lxAddServicio(cta.getAttribute('data-servicio') || 'Name cards');
        var msg = form.querySelector('[name="contact[Mensaje]"]');
        if (msg && !msg.value.trim()) {
          msg.value = 'Name cards como la muestra (' + (nameIn.value.trim() || fallback) + ', mesa ' + (mesaIn.value.trim() || '1') + ').';
        }
      });
    });
  }

  /* 3) consulta privada */
  function initForm() {
    var form = document.querySelector('[data-lx-form]');
    if (!form) return;
    var realForm = form.querySelector('form');
    if (!realForm) return; // vista de "consulta recibida"
    realForm.noValidate = true; // la validación la hace este script, con mensajes en español

    var groups = {};
    form.querySelectorAll('[data-lx-group]').forEach(function (g) {
      var key = g.getAttribute('data-lx-group');
      var multi = g.getAttribute('data-multi') === 'true';
      var optional = g.getAttribute('data-optional') === 'true';
      var hidden = form.querySelector('[data-lx-hidden="' + key + '"]');
      var chips = Array.prototype.slice.call(g.querySelectorAll('.lx-chip'));
      var state = { key: key, multi: multi, values: [] };
      chips.forEach(function (c) { if (c.getAttribute('aria-pressed') === 'true') state.values.push(c.dataset.value); });
      state.set = function (vals) {
        state.values = vals;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', vals.indexOf(c.dataset.value) > -1 ? 'true' : 'false'); });
        if (hidden) hidden.value = vals.join(' | ');
        update();
      };
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var v = c.dataset.value, cur = state.values.slice(), i = cur.indexOf(v);
          if (multi) { if (i > -1) cur.splice(i, 1); else cur.push(v); }
          else if (i > -1) { if (optional) cur = []; }
          else cur = [v];
          state.set(cur);
        });
      });
      if (hidden) hidden.value = state.values.join(' | ');
      groups[key] = state;
    });

    function vals(k) { return groups[k] ? groups[k].values : []; }
    function has(k, test) { return vals(k).some(test); }
    function field(name) { return form.querySelector('[name="contact[' + name + ']"]'); }
    function show(key, on) {
      form.querySelectorAll('[data-lx-show="' + key + '"]').forEach(function (n) {
        n.hidden = !on;
        n.querySelectorAll('input,select,textarea').forEach(function (i) { i.disabled = !on; });
      });
    }

    function flags() {
      var integral = has('servicio', function (x) { return /^Proyecto integral/.test(x); });
      var live = integral || has('servicio', function (x) { return /en vivo/i.test(x); }) || has('modalidad', function (x) { return /en vivo/i.test(x); });
      var pre = integral || has('servicio', function (x) { return /previa/i.test(x); }) || has('modalidad', function (x) { return /anticipación|^Producción previa/i.test(x); });
      return {
        integral: integral, live: live, pre: pre,
        tel: vals('contacto')[0] === 'WhatsApp',
        espacioOtro: vals('espacio')[0] === 'Otro',
        servicioOtro: vals('servicio').indexOf('Otro') > -1
      };
    }

    var summary = form.querySelector('[data-lx-summary]');
    function update() {
      var f = flags();
      show('espacio-otro', f.espacioOtro);
      show('servicio-otro', f.servicioOtro);
      show('integral', f.integral);
      show('entrega', f.pre);
      show('duracion', f.live);
      show('tel', f.tel);
      if (summary) {
        var esp = vals('espacio')[0] || '';
        if (esp === 'Otro') esp = (field('Tipo de espacio (otro)') || {}).value || 'Otro';
        var n = vals('servicio').length;
        var inv = parseInt((field('Invitados aproximados') || {}).value, 10);
        summary.textContent = [esp, n ? n + (n === 1 ? ' servicio' : ' servicios') : '', inv > 0 ? inv + ' invitados' : ''].filter(Boolean).join(' · ');
      }
    }

    form.__lxAddServicio = function (v) {
      if (groups.servicio && groups.servicio.values.indexOf(v) === -1) groups.servicio.set(groups.servicio.values.concat(v));
    };
    document.querySelectorAll('[data-lx-espacio]').forEach(function (a) {
      a.addEventListener('click', function () {
        if (groups.espacio) groups.espacio.set([a.getAttribute('data-lx-espacio')]);
      });
    });

    function today() {
      var d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().slice(0, 10);
    }
    form.querySelectorAll('input[type="date"]').forEach(function (i) { i.min = today(); });

    function setErr(name, on) {
      var el = field(name);
      var msg = form.querySelector('[data-lx-err="' + name + '"]');
      if (el) el.setAttribute('aria-invalid', on ? 'true' : 'false');
      if (msg) msg.hidden = !on;
      return on;
    }
    function posInt(v) { v = String(v || '').trim(); return v === '' || /^[1-9]\d*$/.test(v); }
    function future(v) { return !v || v > today(); }

    function validate() {
      var f = flags(), bad = false;
      bad = setErr('Nombre y cargo', !field('Nombre y cargo').value.trim()) || bad;
      bad = setErr('Marca o empresa', !field('Marca o empresa').value.trim()) || bad;
      bad = setErr('email', !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(field('email').value.trim())) || bad;
      var tel = field('WhatsApp');
      var digits = tel ? tel.value.replace(/\D/g, '') : '';
      bad = setErr('WhatsApp', f.tel && (digits.length < 8 || digits.length > 15)) || bad;
      bad = setErr('Invitados aproximados', !posInt(field('Invitados aproximados').value)) || bad;
      bad = setErr('Piezas a personalizar', !posInt(field('Piezas a personalizar').value)) || bad;
      bad = setErr('Fecha del evento o de entrega', !future(field('Fecha del evento o de entrega').value)) || bad;
      var ent = field('Fecha de entrega previa');
      bad = setErr('Fecha de entrega previa', f.pre && ent && !future(ent.value)) || bad;
      var all = form.querySelector('[data-lx-err-all]');
      if (all) all.hidden = !bad;
      return !bad;
    }

    form.addEventListener('input', function (e) {
      if (e.target.name === 'contact[Invitados aproximados]' || e.target.name === 'contact[Tipo de espacio (otro)]') update();
      if (form.__lxTried) validate();
    });
    form.addEventListener('submit', function (e) {
      form.__lxTried = true;
      if (!validate()) {
        e.preventDefault();
        var first = form.querySelector('[aria-invalid="true"]');
        if (first) first.focus();
        return;
      }
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = btn.getAttribute('data-sending') || 'Enviando…'; }
    });

    update();
  }

  ready(function () { initReveal(); initCards(); initForm(); });
})();
